
class EventUtils {
	private static lastTimeOut: any;
	private static counter: number = 0;
	public static debounce(func: () => void, wait: number) {
		if (this.lastTimeOut) {
			clearTimeout(this.lastTimeOut)
		}
		const handler = () => {
			this.counter++;
			func();
		}
		this.lastTimeOut = setTimeout(handler, wait + 100);
	}
}

export default EventUtils;
